import { Module } from 'vuex'
import { RootState } from '@/store'
import { actions } from '@/store/narrowcasting/actions'
import { mutations } from '@/store/narrowcasting/mutations'
import { getters } from '@/store/narrowcasting/getters'
import {
    WinckCollection,
    WinckFilterConfig,
    WinckOffice,
    WinckScheduledCollection,
    WinckScreen,
} from '@/api/client/winck-proxy'


export interface NarrowcastingState {
    loading: boolean,
    saving: boolean,
    error: string|null,
    offices: WinckOffice[]
    screens: WinckScreen[]
    collections: WinckCollection[]
    scheduledCollections: WinckScheduledCollection[]
    filterConfigs: WinckFilterConfig[]
}

const state: NarrowcastingState = {
    loading: false,
    saving: false,
    error: null,
    offices: [],
    screens: [],
    collections: [],
    scheduledCollections: [],
    filterConfigs: [],
}

export const NarrowcastingModule: Module<NarrowcastingState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
